export default "__VITE_ASSET__3b864e05__"